import http from '../lib/http';
import {findGetParameter} from '../lib/util';

export const SET_DEVICE_NAME_START = 'SET_DEVICE_NAME_START';
export const SET_DEVICE_NAME_ERROR = 'SET_DEVICE_NAME_ERROR';
export const SET_DEVICE_NAME_SUCCESS = 'SET_DEVICE_NAME_SUCCESS';

export const SEND_LOCALESTORAGE_START = 'SEND_LOCALESTORAGE_START';
export const SEND_LOCALESTORAGE_ERROR = 'SEND_LOCALESTORAGE_ERROR';
export const SEND_LOCALESTORAGE_SUCCESS = 'SEND_LOCALESTORAGE_SUCCESS';

export const GET_ORGANIZATION_NAME_START = 'GET_ORGANIZATION_NAME_START';
export const GET_ORGANIZATION_NAME_ERROR = 'GET_ORGANIZATION_NAME_ERROR';
export const GET_ORGANIZATION_NAME_SUCCESS = 'GET_ORGANIZATION_NAME_SUCCESS';

export const CHANGE_DEVICE_SETTINGS = 'CHANGE_DEVICE_SETTINGS';

export function changeDeviceSettings(type, value) {
    return {
        type: CHANGE_DEVICE_SETTINGS,
        payload: {type, value}
    };
}

export function getOrganizationName() {
    return {
        type: 'GET_ORGANIZATION_NAME',
        payload: {
            promise: getGetOrganizationName()
        }
    };
}

export function sendLocaleStorage(localStorage, deviceId, note) {
    return {
        type: 'SEND_LOCALESTORAGE',
        payload: {
            promise: postLocaleStorage(localStorage, deviceId, note)
        }
    };
}


export function setDeviceName(form) {
    return {
        type: 'SET_DEVICE_NAME',
        payload: {
            promise: postDeviceName(form)
        }
    };
}

async function postLocaleStorage(localeStorage, deviceId, note) {
    const res = await http.post(`/app/send-localestorage/${deviceId}`, {
        body: {
            localeStorage,
            note
        }
    });
    if (res.status < 300) return res.json();
    throw res;
}


async function getGetOrganizationName() {

    if (!localStorage.getItem('domain')) {
        const queryDomain = findGetParameter('domain');
        if(!!queryDomain) {
            localStorage.setItem('domain', queryDomain);
        } else {
            throw 'NoDomain';
        }
    }
    const res = await http.get(`/app/organization-name`);
    if (res.status < 300) return res.json();
    throw res;
}

async function postDeviceName(form) {
    const res = await http.post(`/app/device-name`, {body: form});
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/device/actions.js